<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-100">
      <img id="login-logo" src="/img/logo-name.png">
    </div>
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card header-color>
        <p slot="description" class="description" id="loginTitle">Login</p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email</label>
          <md-input @keydown.enter="verifyEmailAndPassword" @keydown="tooltipActive = false" v-model="email" type="email"
            v-validate="'required|email'"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Senha</label>
          <md-input @keydown.enter="verifyEmailAndPassword" @keydown="tooltipActive = false" type="password"
            v-model="password" v-validate="'required'"></md-input>
        </md-field>
        <!-- Pin Field-->
        <md-field class="md-form-group" slot="inputs" v-if="this.showPinInput">
          <md-icon>pin</md-icon>
          <label>Pin</label>
          <md-input @keydown.enter="executeLogin" @keydown="tooltipActive = false" type="text" v-model="pin"
            v-validate="'required'"></md-input>
        </md-field>


        <md-button @click="verifyEmailAndPassword" slot="footer" class="md-accent md-lg" type="submit"
          v-if="!this.showPinInput">Entrar</md-button>
        <md-button @click="executeLogin" slot="footer" class="md-accent md-lg" type="submit"
          v-if="this.showPinInput">Enviar Código</md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import User from "@/models/user.model.vue";
import session from "@/models/session.vue";

import { LoginCard } from "@/components";

import EspressoAux from "@/components/Espresso/EspressoAux.vue";

export default {
  components: {
    LoginCard
  },
  methods: {
    verifyEmailAndPassword: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.sendPinEmail()
        } else {
          EspressoAux.showFailModal("Preencha os campos de login corretamente.");
        }
      })
    },
    executeLogin: async function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          //Verify Pin if all fileds ok
          this.verifyPin().then(pin => {
            console.log(pin)

            if (pin.success) {
              //Login by e-mail if pin ok
              return User.login(this.email, this.password)
                .then(success => {
                  if (success) {
                    //Valid pin and password
                    const url = session.getItem("originalUrl");
                    if (!url) {
                      this.$router.push("/visao-geral");
                    } else {
                      this.$router.push(url);
                    }
                  } else {
                    throw Error("ERR_LOGIN");
                  }
                }).catch(error => {
                  console.log("error status", JSON.stringify(error));
                  if (error.message === "ERR_API_INCORRECT_EMAIL_OR_PASSWORD") {
                    EspressoAux.showFailModal("Email ou senha incorretos.");
                  } else {
                    EspressoAux.showFailModal();
                    console.error(error);
                  }
                });
            }

          }).catch(err => {
            console.log(err)
            if (err.message == 'ERR_API_INCORRECT_EMAIL_OR_PIN') {
              EspressoAux.showFailModal("Código informado inválido ou expirado");
            } else {
              EspressoAux.showFailModal("Erro interno de servidor, por favor contate o administrador.");
            }
          })




        } else {
          EspressoAux.showFailModal("Preencha os campos de login corretamente.");
        }
      })


    },
    sendPinEmail: async function () {
      try {
        const response = await User.loginSendPin({
          email: this.email
        });
        if (response.success) {
          EspressoAux.showSuccessPinModal(`O código foi enviado para o e-mail ${this.email}. Caso não tenha recebido, verifique sua caixa de lixo-eletrônico`)
          this.showPinInput = true
        }
      } catch (error) {
        //alert(error)
        EspressoAux.showFailModal()
        return false
      }
      return true
    },
    verifyPin: async function () {
      return await User.verifyPin({ email: this.email, pinCode: this.pin });
    },
  },
  data() {
    return {
      email: "",
      password: "",
      pin: "",
      showPinInput: false
    };
  },
  async created() {
    if (await session.isActive()) {
      this.$router.push("/visao-geral");
    }
  }
};
</script>

<style>
#loginTitle {
  font-size: 24px;
  color: black;
  margin-bottom: 40px;
  margin-top: -15px;
}

#login-logo {
  height: auto;
  margin: 25px auto;
  width: 100px;
  display: block;
}

@media (max-width: 768px) {
  .login-page.page-header>.container {
    padding-top: 0;
  }
}
</style>

